<template>
    <div>
        <pdf :src="src"></pdf>
    </div>
</template>
<script>
import pdf from "vue-pdf";
export default {
    components: {
        pdf,
    },
    data() {
        return {
            src: "",
        };
    },
    computed: {
        pdfInfo() {
            // 这个是路由跳转携带的关于pdf的信息，包含链接，链接是可以直接打开pdf文件的
            return this.$route.query.pdfInfo;
        },
    },
    created() {
        console.log(this.pdfInfo.url);
        // 有时PDF文件地址会出现跨域的情况,这里最好处理一下
        this.src = pdf.createLoadingTask(
            `https://wowoto.oss-cn-shanghai.aliyuncs.com/pinboo/${this.pdfInfo.url}`
        );
    },
};
</script>
